import api from './api'
import { API_ENDPOINTS } from '../config/api'

const userService = {
  getAllDetails: async (page = 1, limit = 25, search = '', { exact, parentId } = {}) => {
    const params = { page, limit }
    if (exact) {
      params.exact = exact
    } else if (search) {
      params.search = search
    }
    // Drill-down: direct children of this staff instead of the logged-in account's
    if (parentId) {
      params.parentId = parentId
    }
    const response = await api.get(API_ENDPOINTS.USER.ALL_DETAILS, { params })
    return response.data
  },
  // Live availability check — server answers by status code (200 = available,
  // 202 = taken), so the caller needs the full response, not just data.
  // Header "Search User": usernames in the caller's downline that contain
  // `username` (GET /admin/search-by-username, wallet rows). `signal`
  // lets the typeahead abort a stale request on the next keystroke.
  searchByUsername: async (username, signal, { page = 1, limit = 20 } = {}) => {
    const response = await api.get(API_ENDPOINTS.USER.SEARCH_BY_USERNAME, {
      params: { username, page, limit },
      signal,
    })
    return response.data
  },
  // One account's own details, read fresh from users/staff (the list row can
  // be stale, and rows created before 2026-09-18 carry no fullname/city at
  // all). accountType: 'USER' | 'STAFF'.
  getAccountDetails: async (accountType, id, signal) => {
    const response = await api.get(API_ENDPOINTS.USER.ACCOUNT_DETAILS(accountType, id), { signal })
    return response.data
  },

  checkUsername: async (username, signal) => {
    return api.get(API_ENDPOINTS.USER.CHECK_USERNAME, {
      params: { username },
      signal,
      skipLoader: true,
    })
  },
  createUser: async (data) => {
    const response = await api.post(API_ENDPOINTS.USER.CREATE_USER, data)
    return response.data
  },
  createStaff: async (data) => {
    const response = await api.post(API_ENDPOINTS.USER.CREATE_STAFF, data)
    return response.data
  },
  updateStatusAndPassword: async (data) => {
    const response = await api.put(API_ENDPOINTS.USER.UPDATE_STATUS_PASSWORD, data)
    return response.data
  },
}

export default userService
